module.exports = __webpack_public_path__ + "img/wechatpay.8d6cd284.png";